import { render, staticRenderFns } from "./audit-trail-container.vue?vue&type=template&id=0822843d&scoped=true&lang=pug"
import script from "./audit-trail-container.js?vue&type=script&lang=js&external"
export * from "./audit-trail-container.js?vue&type=script&lang=js&external"
import style0 from "./audit-trail-container.vue?vue&type=style&index=0&id=0822843d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0822843d",
  null
  
)

export default component.exports